import { RoulettePocketColor } from '../enums/RoulettePocketColor';
import { RoulettePocketsDefinition } from './RoulettePocketsDefinition';
import { RouletteLowHighBetType } from '../enums/RouletteLowHighBetType';
import { RouletteOddEvenBetType } from '../enums/RouletteOddEvenBetType';
import { RouletteColumn } from '../enums/RouletteColumn';
import { RouletteDozen } from '../enums/RouletteDozen';
import { RouletteFrenchSection } from '../enums/RouletteFrenchSection';
import { RouletteType } from '../enums/RouletteType';
var RoulettePocketDetailsDTO = /** @class */ (function () {
    function RoulettePocketDetailsDTO(pocket, type) {
        this.pocket = pocket;
        this.type = type;
    }
    Object.defineProperty(RoulettePocketDetailsDTO.prototype, "value", {
        get: function () {
            return this.pocket;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(RoulettePocketDetailsDTO.prototype, "color", {
        get: function () {
            if (RoulettePocketsDefinition.color.red.includes(this.pocket)) {
                return RoulettePocketColor.RED;
            }
            if (RoulettePocketsDefinition.color.black.includes(this.pocket)) {
                return RoulettePocketColor.BLACK;
            }
            return RoulettePocketColor.GREEN;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(RoulettePocketDetailsDTO.prototype, "lowHigh", {
        get: function () {
            if (RoulettePocketsDefinition.low.includes(this.pocket)) {
                return RouletteLowHighBetType.LOW;
            }
            if (RoulettePocketsDefinition.high.includes(this.pocket)) {
                return RouletteLowHighBetType.HIGH;
            }
            return undefined;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(RoulettePocketDetailsDTO.prototype, "oddEven", {
        get: function () {
            if (RoulettePocketsDefinition.odd.includes(this.pocket)) {
                return RouletteOddEvenBetType.ODD;
            }
            if (RoulettePocketsDefinition.even.includes(this.pocket)) {
                return RouletteOddEvenBetType.EVEN;
            }
            return undefined;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(RoulettePocketDetailsDTO.prototype, "column", {
        get: function () {
            if (RoulettePocketsDefinition.column.first.includes(this.pocket)) {
                return RouletteColumn.FIRST;
            }
            if (RoulettePocketsDefinition.column.second.includes(this.pocket)) {
                return RouletteColumn.SECOND;
            }
            if (RoulettePocketsDefinition.column.third.includes(this.pocket)) {
                return RouletteColumn.THIRD;
            }
            return undefined;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(RoulettePocketDetailsDTO.prototype, "dozen", {
        get: function () {
            if (RoulettePocketsDefinition.dozen.first.includes(this.pocket)) {
                return RouletteDozen.FIRST;
            }
            if (RoulettePocketsDefinition.dozen.second.includes(this.pocket)) {
                return RouletteDozen.SECOND;
            }
            if (RoulettePocketsDefinition.dozen.third.includes(this.pocket)) {
                return RouletteDozen.THIRD;
            }
            return undefined;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(RoulettePocketDetailsDTO.prototype, "frenchSections", {
        get: function () {
            if (this.type === RouletteType.AMERICAN) {
                return [];
            }
            var sections = [];
            if (RoulettePocketsDefinition.frenchSection.zero.includes(this.pocket)) {
                sections.push(RouletteFrenchSection.ZERO);
            }
            if (RoulettePocketsDefinition.frenchSection.tier.includes(this.pocket)) {
                sections.push(RouletteFrenchSection.TIERS);
            }
            if (RoulettePocketsDefinition.frenchSection.orphelins.includes(this.pocket)) {
                sections.push(RouletteFrenchSection.ORPHELINS);
            }
            if (RoulettePocketsDefinition.frenchSection.voisins.includes(this.pocket)) {
                sections.push(RouletteFrenchSection.VOISINS);
            }
            return sections;
        },
        enumerable: false,
        configurable: true
    });
    return RoulettePocketDetailsDTO;
}());
export { RoulettePocketDetailsDTO };
